import { VacantRentalObject } from './vacant-rental-object';

export class VacantPremises extends VacantRentalObject {
  constructor() {
    super();
  }
}
